import { useCallback, useState } from 'react';

import { NemuruDialog, NemuruDialogProps } from '../components/NemuruDialog';

export const useDialog = () => {
  const [opened, setOpened] = useState<boolean>(false);

  const toggleDialog = () => {
    setOpened(!opened);
  };

  const DialogComponent = (props: Omit<NemuruDialogProps, 'opened' | 'setOpened'>) => (
    <NemuruDialog opened={opened} setOpened={setOpened} {...props} children={props.children} />
  );

  return {
    opened,
    toggleDialog,
    setOpened,
    DialogComponent: useCallback(DialogComponent, [opened]),
  };
};
